import React from 'react';
import VenturiLoader from './VenturiLoader';

/**
 * PageLoader Component
 * Legacy wrapper rendering the unified VenturiLoader under the hood.
 * 
 * @param {Object} props
 * @param {string} props.title - Loading message
 * @param {string} props.message - Supporting text
 */
const PageLoader = ({ title = 'Loading...', message = 'Please wait while we prepare your data...' }) => {
  return (
    <div className="page-loader" style={{ position: 'relative', width: '100%', height: '100%', minHeight: '400px' }}>
      <VenturiLoader message={title} subMessage={message} />
    </div>
  );
};

export default PageLoader;
